import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormikRadioButton from '../../ui/FormikRadioButton';

import { StatesArray } from '../../global/constants';

import { BlueSwipeIndAccountBillingFormSchema, BlueSwipeBusAccountBillingFormSchema } from './validation';

const mapStateToProps = state => ({
  dashboard: state.Dashboard
});

const cssFormControlError = "form-control error-input";
const cssFormControl = "form-control";

export const getClassNames = (errors, touched) => {
  const firstNameClass = (errors.firstName && touched.firstName) ? cssFormControlError : cssFormControl;
  const lastNameClass = (errors.lastName && touched.lastName) ? cssFormControlError : cssFormControl;
  const businessNameClass = (errors.businessName && touched.businessName) ? cssFormControlError : cssFormControl;
  const tinClass = (errors.tin && touched.tin) ? cssFormControlError : cssFormControl;
  const addressClass = (errors.address && touched.address && errors.address.address1 && touched.address.address1) ?
    cssFormControlError : cssFormControl;
  const addressClass2 = (errors.address && touched.address && errors.address.address2 && touched.address.address2) ?
    cssFormControlError : cssFormControl;
  const zipClass = (errors.address && touched.address && errors.address.zip && touched.address.zip) ? cssFormControlError : cssFormControl;

  return {
    firstNameClass,
    lastNameClass,
    businessNameClass,
    tinClass,
    addressClass,
    addressClass2,
    zipClass
  }
}

export function buildDropdown(name, options, placeholder, selectText, hasError) {
  return (
    <Field
      component="select"
      placeholder={placeholder ? placeholder : ''}
      name={name}
      className={hasError ? cssFormControlError : cssFormControl}>
      <option value="" disabled={true}>{selectText}</option>
      {options && options.map((v) => { return (<option key={v} value={v}>{v}</option>) })}
    </Field>);
}

class BankAccountBillingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
      hasSubmitted: false,
      resetForm: null,
      type: null
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.isAddressAndCityInvalid = this.isAddressAndCityInvalid.bind(this);
    this.getInitialValues = this.getInitialValues.bind(this);
    this.shouldResetForm = this.shouldResetForm.bind(this);
  }

  getInitialValues = () => {
    const user = this.props.dashboard.user;
    if (!user)
      return null;

    return user.accountBilling && user.accountBilling.type ? user.accountBilling :
      {
        type: 'individual',
      };
  }

  shouldResetForm = (prevProps) => {
    const updatedAddress = this.props.dashboard.user.accountBilling;
    const oldAddress = prevProps.dashboard.user.accountBilling;

    return JSON.stringify(updatedAddress) !== JSON.stringify(oldAddress);
  }

  componentDidMount() {
    if (!this.state.type) {
      const initialValues = this.getInitialValues();
      this.setState({ type: initialValues ? initialValues.type : this.state.type })
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.type) {
      const initialValues = this.getInitialValues();
      this.setState({ type: initialValues ? initialValues.type : this.state.type })
    }

    if (this.shouldResetForm(prevProps) && this.state.resetForm) {
      let resetForm = this.state.resetForm;
      resetForm();
      this.setState({ resetForm: null });
    }
  }

  onSubmit(values, form) {
    let { onSubmit } = this.props;
    this.setState({ hasSubmitted: true, resetForm: form.resetForm });
    onSubmit(values, form);
  }

  isAddressAndCityInvalid = (errors, touched) => {
    return errors.address && touched.address && errors.address.city && touched.address.city;
  }

  renderCityState(isMobile, errors, touched) {
    const cityClass = this.isAddressAndCityInvalid(errors, touched) ? cssFormControlError : cssFormControl;
    return isMobile
      //Mobile View
      ? (<div><div className="fieldgroup fieldgroup-required">
        <Field
          name="address.city"
          type="text"
          placeholder="City"
          className={cityClass}
        />
        <ErrorMessage name="address.city" component="div" className="error-message" />
      </div><div className="fieldgroup fieldgroup-required">
          {buildDropdown("address.state", StatesArray, "State", "State", (errors.address && touched.address && errors.address.state && touched.address.state))}
          <ErrorMessage name="address.state" component="div" className="error-message" />
        </div></div>)
      //Desktop View
      : (<div className="fieldgroup row">
        <div className="col-8 pl-0 fieldgroup-required">
          <Field
            name="address.city"
            type="text"
            placeholder="City"
            className={cityClass}
          />
        </div>
        <div className="col-4 pr-0 fieldgroup-required fieldgroup-select">
          {buildDropdown("address.state", StatesArray, "State", "State", (errors.address && touched.address && errors.address.state && touched.address.state))}
        </div>
        {(errors.address && touched.address
          && ((errors.address.city && touched.address.city) || (errors.state && touched.state)))
          && (<div className="error-message">This field is required</div>)}
      </div>)
  }

  render() {
    let { errorMessage, isMobile, isModal } = this.props;
    let { type, hasSubmitted } = this.state;

    const initialValues = this.getInitialValues();

    if (!initialValues)
      return (<div><div className="mb-3">Loading Billing Information...</div></div>);

    return (
      <div>
        <h5>Account Type</h5>
        <Formik
          validationSchema={type === 'individual' ? BlueSwipeIndAccountBillingFormSchema : BlueSwipeBusAccountBillingFormSchema}
          initialValues={initialValues}
          enableReinitialize={true}
          validateOnBlur={true}
          onSubmit={this.onSubmit}>
          {({ values, errors, touched, dirty, isSubmitting }) => {
            const classNames = getClassNames(errors, touched);
            return (
              <Form>
                <div className="d-flex">
                  <div className="ml-3 fieldgroup">
                    <FormikRadioButton
                      name="type"
                      value="individual"
                      label="Individual"
                    />
                  </div>
                  <div className="ml-3 fieldgroup">
                    <FormikRadioButton
                      name="type"
                      value="business"
                      label="Business" />
                  </div>
                </div>
                <div className="mb-3">
                  <h5>Billing Address</h5>
                  <div><i className="fas fa-asterisk required-asterisk"></i> Indicates required field</div>
                  <div>
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="firstName"
                        type="text"
                        placeholder="First Name"
                        className={classNames.firstNameClass}
                      />
                      <ErrorMessage name="firstName" component="div" className="error-message" />
                    </div>
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="lastName"
                        type="text"
                        placeholder="Last Name"
                        className={classNames.lastNameClass}
                      />
                      <ErrorMessage name="lastName" component="div" className="error-message" />
                    </div>
                    {values.type === 'business' && (
                      <div className="fieldgroup fieldgroup-required">
                        <Field
                          name="businessName"
                          type="text"
                          placeholder="Company Name"
                          className={classNames.businessNameClass}
                        />
                        <ErrorMessage name="businessName" component="div" className="error-message" />
                      </div>
                    )}
                    {values.type === 'business' && (
                      <div className="fieldgroup fieldgroup-required">
                        <Field
                          name="tin"
                          type="text"
                          placeholder="Company TIN"
                          className={classNames.tinClass}
                        />
                        <ErrorMessage name="tin" component="div" className="error-message" />
                      </div>
                    )}
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="address.address1"
                        type="text"
                        placeholder="Address Line 1"
                        className={classNames.addressClass}
                      />
                      <ErrorMessage name="address.address1" component="div" className="error-message" />
                    </div>
                    <div className="fieldgroup">
                      <Field
                        name="address.address2"
                        type="text"
                        placeholder="Address Line 2 (Optional)"
                        className={classNames.addressClass2}
                      />
                    </div>
                    {this.renderCityState(isMobile, errors, touched)}
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="address.zip"
                        type="text"
                        pattern="[0-9]*"
                        placeholder="Zip Code"
                        className={classNames.zipClass}
                      />
                      <ErrorMessage name="address.zip" component="div" className="error-message" />
                    </div>
                  </div>
                  <div>
                    {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                    <div className={`button-row row ${isModal ? 'modal-footer pb-0' : ''}`}>
                      <div className="col">
                        <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Update'}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    )
  }
}

export default connect(mapStateToProps)(BankAccountBillingForm);
